// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--PTTS8";
export var main = "styles-module--main--ishjm";